var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{style:(_vm.combinedStyle),on:{"click":function($event){return _vm.$emit('click', $event.target ? $event.target.value : false)},"keypress":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;return _vm.keypressSpace.apply(null, arguments)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }